export default {
    getHeaderFields: state => state.headerFields,
    getDataTableOptions: state => state.dataTableOptions,
    getRowActions: state => state.rowActions,
    getActions: state => state.actions,
    getSearchFields: state => state.searchFields
}
